import React from "react";

export default function CircleIcon({className}) {
    return (<svg className={className} viewBox="0 0 92 92" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
        <circle cx="46" cy="46" r="46" fill="currentColor"/>
    </svg>)
}
